/**
 * Shared MUI component styles used across task/todo detail components.
 *
 * These style objects were extracted from SubTaskDetails.tsx and ToDoDetails.tsx
 * to eliminate duplication.
 */

export const sharedSx = {
	"min-width": "160px",
	"& .MuiSelect-select": {
		padding: "9.5px 8px !important",
		fontSize: "14px",
		lineHeight: "1.5",
	},
	"& .MuiInputBase-root": {
		marginBottom: "0px",
		borderRadius: "12px",
		fontSize: "14px",
		padding: "0px !important",
	},
	"& .MuiOutlinedInput-root": {
		padding: "0px !important",
	},
	"& .MuiAutocomplete-inputRoot": {
		padding: "8px !important",
	},
	"& .MuiSelect-icon": {
		color: "#1D243C",
	},
};

export const sharedInputProps = {
	style: {
		display: "flex",
		alignItems: "center",
		fontSize: "14px",
	},
};

export const sharedMenuProps = {
	PaperProps: {
		sx: {
			padding: "8px",
			marginTop: "4px",
			borderRadius: "12px",
			"& .MuiList-root": {
				margin: "0px",
				padding: "0px",
				gap: "8px",
				display: "flex",
				flexDirection: "column",
			},
			"& .MuiMenuItem-root": {
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				fontSize: "14px",
				margin: "0px",
				padding: "0px",
				backgroundColor: "transparent !important",
				"&.Mui-selected": {
					color: "#4680FC",
				},
				"&:hover": {
					backgroundColor: "transparent !important",
				},
			},
		},
	},
};
